import { RugbyLeagueEventStatusId } from '@collector/sportsapi-client-legacy'

export const eventStatuses: RugbyLeagueEventStatusId[] = [
  RugbyLeagueEventStatusId.NotStarted,
  RugbyLeagueEventStatusId.FirstHalf,
  RugbyLeagueEventStatusId.Halftime,
  RugbyLeagueEventStatusId.SecondHalf,
  RugbyLeagueEventStatusId.WaitingForExtratime,
  RugbyLeagueEventStatusId.ExtratimeFirstHalf,
  RugbyLeagueEventStatusId.ExtratimeHalftime,
  RugbyLeagueEventStatusId.ExtratimeSecondHalf,
  RugbyLeagueEventStatusId.WaitingForPenalty,
  RugbyLeagueEventStatusId.Penalties,
  RugbyLeagueEventStatusId.FinishedRegularTime,
  RugbyLeagueEventStatusId.FinishedAfterExtratime,
  RugbyLeagueEventStatusId.Interrupted,
  RugbyLeagueEventStatusId.Postponed,
  RugbyLeagueEventStatusId.Abandoned,
  RugbyLeagueEventStatusId.Cancelled,
  RugbyLeagueEventStatusId.ToFinish,
]
